import { render, staticRenderFns } from "./WizardExport.vue?vue&type=template&id=97156812&scoped=true&"
import script from "./WizardExport.vue?vue&type=script&lang=js&"
export * from "./WizardExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97156812",
  null
  
)

export default component.exports